import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M17.708 8.13a6.891 6.891 0 0 0-9.155-2.106 6.89 6.89 0 0 0-3.41 5.251.6.6 0 1 1-1.193-.127 8.09 8.09 0 0 1 4.003-6.163 8.091 8.091 0 0 1 10.72 2.43l.248-.923a.6.6 0 1 1 1.159.31l-.646 2.411a.6.6 0 0 1-.735.425l-2.409-.646a.6.6 0 1 1 .311-1.16l1.107.297Zm1.808 4.061a.6.6 0 0 1 .534.66 8.09 8.09 0 0 1-4.003 6.164 8.091 8.091 0 0 1-10.72-2.43l-.247.922a.6.6 0 1 1-1.16-.31l.646-2.41a.6.6 0 0 1 .735-.425l2.409.646a.6.6 0 1 1-.311 1.159l-1.107-.297a6.891 6.891 0 0 0 9.155 2.106 6.89 6.89 0 0 0 3.41-5.252.6.6 0 0 1 .66-.533Z"
      clip-rule="evenodd"
    />
  </svg>
`;
